"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSectionSubscriptions = exports.isRemoteConsumption = exports.getConsumptionsState = exports.getConsumptions = exports.getStepDefinitionConfig = exports.getConsumptionsSum = exports.getConsumptionsEndDate = exports.getConsumptionsBeginDate = exports.getConsumptionsIntervalDetails = exports.getConsumptionsStepTitle = exports.getConsumptionsCurrentStepDefinition = exports.getConsumptionsCurrentMonthAndYear = exports.getConsumptionsInterval = exports.getFormatedConsumptions = exports.getConsumptionsStatus = exports.firstLetterToUpperCase = exports.formatDate = void 0;
var ConsumptionsState_1 = require("../states/ConsumptionsState");
var index_1 = __importStar(require("../i18n/index"));
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var decimal_js_1 = require("decimal.js");
var dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/fr");
var weekOfYear_1 = __importDefault(require("dayjs/plugin/weekOfYear"));
dayjs_1.default.extend(weekOfYear_1.default);
function formatDate(rangeType, stepDefinition, date, language, endDate) {
    if (language === void 0) { language = 'fr'; }
    if (endDate === void 0) { endDate = false; }
    if (rangeType.toUpperCase() === 'MONTH') {
        var month = new Intl.DateTimeFormat(language, {
            month: 'long'
        }).format(new Date(date));
        return month.charAt(0).toUpperCase() + month.slice(1);
    }
    if (rangeType.toUpperCase() === 'YEAR') {
        return new Intl.DateTimeFormat(language, { year: 'numeric' }).format(new Date(date));
    }
    if (rangeType.toUpperCase() === 'DAY' &&
        stepDefinition === ConsumptionsState_1.StepDefinitions.Month) {
        return new Intl.DateTimeFormat(language, { day: 'numeric' }).format(new Date(date));
    }
    if (rangeType.toUpperCase() === 'DAY' &&
        stepDefinition === ConsumptionsState_1.StepDefinitions.Week) {
        var toCompare = new Date(date);
        toCompare.setDate(new Date(date).getDate() + 6);
        if (endDate)
            return new Intl.DateTimeFormat(language, {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
            }).format(new Date(date));
        if (toCompare.getMonth() + 1 == //getMonth() is 0 based index ex : 0 for january 11 for dec
            parseInt(new Intl.DateTimeFormat(language, { month: 'numeric' }).format(new Date(date))))
            return new Intl.DateTimeFormat(language, {
                weekday: 'long',
                day: 'numeric'
            }).format(new Date(date));
        return new Intl.DateTimeFormat(language, {
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }).format(new Date(date));
    }
    return '';
}
exports.formatDate = formatDate;
function firstLetterToUpperCase(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
exports.firstLetterToUpperCase = firstLetterToUpperCase;
function getConsumptionsStatus(states) {
    var _a, _b;
    return {
        loading: (_a = states === null || states === void 0 ? void 0 : states.consumptions) === null || _a === void 0 ? void 0 : _a.loading,
        loaded: (_b = states === null || states === void 0 ? void 0 : states.consumptions) === null || _b === void 0 ? void 0 : _b.loaded
    };
}
exports.getConsumptionsStatus = getConsumptionsStatus;
function getFormatedConsumptions(state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var lang = (0, settingsSelectors_1.getLanguage)(state);
    var translation = (0, index_1.default)(lang ? lang : index_1.langTypes.FR);
    switch ((_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.stepDefinition) {
        case ConsumptionsState_1.StepDefinitions.Year: {
            if (((_c = (_b = state === null || state === void 0 ? void 0 : state.consumptions) === null || _b === void 0 ? void 0 : _b.data[0]) === null || _c === void 0 ? void 0 : _c.rangeType.toUpperCase()) === 'YEAR') {
                return (_d = state === null || state === void 0 ? void 0 : state.consumptions) === null || _d === void 0 ? void 0 : _d.data.map(function (c) {
                    return {
                        x: new Intl.DateTimeFormat(lang, {
                            year: 'numeric'
                        }).format(new Date(c.startDate)),
                        y: c.value,
                        realConsumption: c.realConsumptionValue,
                        estimateConsumption: c.estimateConsumptionValue
                    };
                });
            }
            else if (((_f = (_e = state === null || state === void 0 ? void 0 : state.consumptions) === null || _e === void 0 ? void 0 : _e.data[0]) === null || _f === void 0 ? void 0 : _f.rangeType.toUpperCase()) ===
                'MONTH') {
                return (_g = state === null || state === void 0 ? void 0 : state.consumptions) === null || _g === void 0 ? void 0 : _g.data.map(function (c) {
                    var month = new Intl.DateTimeFormat(lang ? lang : 'fr', {
                        month: 'short'
                    }).format(new Date(c.startDate));
                    return {
                        x: firstLetterToUpperCase(month),
                        y: c.value,
                        realConsumption: c.realConsumptionValue,
                        estimateConsumption: c.estimateConsumptionValue
                    };
                });
            }
            else {
                return null;
            }
        }
        case ConsumptionsState_1.StepDefinitions.Month: {
            return (_h = state === null || state === void 0 ? void 0 : state.consumptions) === null || _h === void 0 ? void 0 : _h.data.map(function (c) {
                var _a;
                return {
                    tooltip: getToolTip(c, translation, lang, ((_a = state.consumptions) === null || _a === void 0 ? void 0 : _a.isEstimateConsumption) || false),
                    x: new Intl.DateTimeFormat(lang, { day: 'numeric' }).format(new Date(c.startDate)),
                    y: c.value,
                    realConsumption: c.realConsumptionValue,
                    estimateConsumption: c.estimateConsumptionValue
                };
            });
        }
        case ConsumptionsState_1.StepDefinitions.Week: {
            return (_j = state === null || state === void 0 ? void 0 : state.consumptions) === null || _j === void 0 ? void 0 : _j.data.map(function (c) {
                return {
                    x: new Intl.DateTimeFormat(lang, {
                        weekday: 'short'
                    }).format(new Date(c.startDate)),
                    y: c.value,
                    realConsumption: c.realConsumptionValue,
                    estimateConsumption: c.estimateConsumptionValue
                };
            });
        }
    }
}
exports.getFormatedConsumptions = getFormatedConsumptions;
function getConsumptionsInterval(state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var lang = (0, settingsSelectors_1.getLanguage)(state);
    var translation = (0, index_1.default)(lang ? lang : index_1.langTypes.FR);
    var headerDescription = (translation === null || translation === void 0 ? void 0 : translation.consumption.currentYearMessage) +
        ' ' +
        ((_a = state.consumptions) === null || _a === void 0 ? void 0 : _a.startYear);
    switch ((_b = state === null || state === void 0 ? void 0 : state.consumptions) === null || _b === void 0 ? void 0 : _b.stepDefinition) {
        case ConsumptionsState_1.StepDefinitions.Year: {
            //on a des données par mois
            if (((_d = (_c = state === null || state === void 0 ? void 0 : state.consumptions) === null || _c === void 0 ? void 0 : _c.data[0]) === null || _d === void 0 ? void 0 : _d.rangeType.toUpperCase()) ===
                'MONTH')
                return headerDescription;
            //on a pas de données
            if (!((_e = state === null || state === void 0 ? void 0 : state.consumptions) === null || _e === void 0 ? void 0 : _e.data.length)) {
                //si on a changé les pas de temps (cas telereleve)
                if (((_f = state === null || state === void 0 ? void 0 : state.consumptions) === null || _f === void 0 ? void 0 : _f.startDay) !=
                    (0, dayjs_1.default)(new Date()).startOf('week').date() ||
                    ((_g = state === null || state === void 0 ? void 0 : state.consumptions) === null || _g === void 0 ? void 0 : _g.startMonth) !=
                        (0, dayjs_1.default)(new Date()).startOf('week').month() + 1 ||
                    ((_h = state === null || state === void 0 ? void 0 : state.consumptions) === null || _h === void 0 ? void 0 : _h.startYear) !=
                        (0, dayjs_1.default)(new Date()).startOf('week').month() + 1) {
                    return headerDescription;
                }
                //si on n'a pas changé les pas de temps (cas radioreleve ou manuel)
                return '';
            }
            if (((_j = state === null || state === void 0 ? void 0 : state.consumptions) === null || _j === void 0 ? void 0 : _j.data.length) === 1) {
                return translation === null || translation === void 0 ? void 0 : translation.consumption.oneYearIntervalMessage;
            }
            return "".concat(translation === null || translation === void 0 ? void 0 : translation.consumption.yearsIntervalMessageDebut, " ").concat((_k = state === null || state === void 0 ? void 0 : state.consumptions) === null || _k === void 0 ? void 0 : _k.data.length, " ").concat(translation === null || translation === void 0 ? void 0 : translation.consumption.yearsIntervalMessageEnd);
        }
        case ConsumptionsState_1.StepDefinitions.Month: {
            var date = (0, dayjs_1.default)(new Date((_l = state.consumptions) === null || _l === void 0 ? void 0 : _l.startYear, ((_m = state.consumptions) === null || _m === void 0 ? void 0 : _m.startMonth) - 1, 1));
            (0, dayjs_1.default)().locale('fr');
            headerDescription =
                (translation === null || translation === void 0 ? void 0 : translation.consumption.fromDate) +
                    ' ' +
                    1 +
                    (translation === null || translation === void 0 ? void 0 : translation.consumption.first) +
                    ' ' +
                    (translation === null || translation === void 0 ? void 0 : translation.consumption.toDate) +
                    ' ' +
                    date
                        .add(1, 'month')
                        .subtract(1, 'day')
                        .locale('fr')
                        .format('DD MMMM YYYY');
            return headerDescription;
        }
        case ConsumptionsState_1.StepDefinitions.Week: {
            var dateStart = (0, dayjs_1.default)(new Date((_o = state.consumptions) === null || _o === void 0 ? void 0 : _o.startYear, ((_p = state.consumptions) === null || _p === void 0 ? void 0 : _p.startMonth) - 1, (_q = state.consumptions) === null || _q === void 0 ? void 0 : _q.startDay));
            var dateEnd = dateStart.add(6, 'day');
            headerDescription =
                (translation === null || translation === void 0 ? void 0 : translation.consumption.fromDate) +
                    ' ' +
                    dateStart.locale('fr').format('DD MMMM') +
                    ' ' +
                    (translation === null || translation === void 0 ? void 0 : translation.consumption.toDate) +
                    ' ' +
                    dateEnd.locale('fr').format('DD MMMM');
            return headerDescription;
        }
        default: {
            return headerDescription;
        }
    }
}
exports.getConsumptionsInterval = getConsumptionsInterval;
function getConsumptionsCurrentMonthAndYear(state) {
    var _a, _b, _c, _d;
    var date = (0, dayjs_1.default)(new Date());
    if (((_a = state.consumptions) === null || _a === void 0 ? void 0 : _a.startYear) && ((_b = state.consumptions) === null || _b === void 0 ? void 0 : _b.startMonth))
        date = (0, dayjs_1.default)(new Date((_c = state === null || state === void 0 ? void 0 : state.consumptions) === null || _c === void 0 ? void 0 : _c.startYear, ((_d = state === null || state === void 0 ? void 0 : state.consumptions) === null || _d === void 0 ? void 0 : _d.startMonth) - 1, 1));
    return date.locale('fr').format('MMMM YYYY');
}
exports.getConsumptionsCurrentMonthAndYear = getConsumptionsCurrentMonthAndYear;
function getConsumptionsCurrentStepDefinition(state) {
    var _a;
    return (_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.stepDefinition;
}
exports.getConsumptionsCurrentStepDefinition = getConsumptionsCurrentStepDefinition;
function getConsumptionsStepTitle(state) {
    var _a, _b, _c, _d, _e, _f, _g;
    var lang = (0, settingsSelectors_1.getLanguage)(state);
    var translation = (0, index_1.default)(lang ? lang : index_1.langTypes.FR);
    switch ((_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.stepDefinition) {
        case ConsumptionsState_1.StepDefinitions.Year: {
            return (_b = state === null || state === void 0 ? void 0 : state.consumptions) === null || _b === void 0 ? void 0 : _b.startYear.toString();
        }
        case ConsumptionsState_1.StepDefinitions.Month: {
            return getConsumptionsCurrentMonthAndYear(state);
        }
        case ConsumptionsState_1.StepDefinitions.Week: {
            var date = new Date((_c = state === null || state === void 0 ? void 0 : state.consumptions) === null || _c === void 0 ? void 0 : _c.startYear, ((_d = state === null || state === void 0 ? void 0 : state.consumptions) === null || _d === void 0 ? void 0 : _d.startMonth) - 1, (_e = state === null || state === void 0 ? void 0 : state.consumptions) === null || _e === void 0 ? void 0 : _e.startDay);
            return (translation === null || translation === void 0 ? void 0 : translation.consumption.week) + ' ' + (0, dayjs_1.default)(date).week();
        }
        default:
            return ((_f = state === null || state === void 0 ? void 0 : state.consumptions) === null || _f === void 0 ? void 0 : _f.startYear)
                ? (_g = state === null || state === void 0 ? void 0 : state.consumptions) === null || _g === void 0 ? void 0 : _g.startYear.toString()
                : '';
    }
}
exports.getConsumptionsStepTitle = getConsumptionsStepTitle;
function getConsumptionsIntervalDetails(state) {
    var _a, _b, _c;
    if (!((_a = state.consumptions) === null || _a === void 0 ? void 0 : _a.data.length)) {
        return '';
    }
    var lang = (0, settingsSelectors_1.getLanguage)(state);
    var translation = (0, index_1.default)(lang ? lang : index_1.langTypes.FR);
    var interval = (translation === null || translation === void 0 ? void 0 : translation.consumption.from) +
        ' ' +
        getConsumptionsBeginDate(state) +
        ' ' +
        (translation === null || translation === void 0 ? void 0 : translation.consumption.to) +
        ' ' +
        getConsumptionsEndDate(state);
    if (!parseInt(getConsumptionsEndDate(state)))
        interval = interval + ' ' + ((_b = state === null || state === void 0 ? void 0 : state.consumptions) === null || _b === void 0 ? void 0 : _b.startYear);
    switch ((_c = state === null || state === void 0 ? void 0 : state.consumptions) === null || _c === void 0 ? void 0 : _c.stepDefinition) {
        case ConsumptionsState_1.StepDefinitions.Year: {
            return interval;
        }
        case ConsumptionsState_1.StepDefinitions.Month: {
            interval =
                (translation === null || translation === void 0 ? void 0 : translation.consumption.fromDate) +
                    ' ' +
                    getConsumptionsBeginDate(state) +
                    ' ' +
                    (translation === null || translation === void 0 ? void 0 : translation.consumption.toDate) +
                    ' ' +
                    getConsumptionsEndDate(state) +
                    ' ' +
                    getConsumptionsCurrentMonthAndYear(state);
            return interval;
        }
        case ConsumptionsState_1.StepDefinitions.Week: {
            interval =
                (translation === null || translation === void 0 ? void 0 : translation.consumption.fromDate) +
                    ' ' +
                    getConsumptionsBeginDate(state) +
                    ' ' +
                    (translation === null || translation === void 0 ? void 0 : translation.consumption.toDate) +
                    ' ' +
                    getConsumptionsEndDate(state);
            return interval;
        }
        default: {
            return interval;
        }
    }
}
exports.getConsumptionsIntervalDetails = getConsumptionsIntervalDetails;
function getConsumptionsBeginDate(state) {
    var _a, _b, _c, _d, _e;
    if ((_b = (_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) {
        var beginDate = '';
        if ((_c = state.consumptions.data) === null || _c === void 0 ? void 0 : _c.length) {
            beginDate = formatDate(state.consumptions.data[0].rangeType, (_d = state === null || state === void 0 ? void 0 : state.consumptions) === null || _d === void 0 ? void 0 : _d.stepDefinition, state.consumptions.data[0].startDate, (_e = state === null || state === void 0 ? void 0 : state.settings) === null || _e === void 0 ? void 0 : _e.language);
        }
        return beginDate;
    }
    return '';
}
exports.getConsumptionsBeginDate = getConsumptionsBeginDate;
function getConsumptionsEndDate(state) {
    var _a, _b, _c, _d;
    if ((_b = (_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) {
        var consumptions = state.consumptions.data;
        var endDate = '';
        if (consumptions === null || consumptions === void 0 ? void 0 : consumptions.length) {
            var today = new Date();
            var maxDate = new Date(consumptions[(consumptions === null || consumptions === void 0 ? void 0 : consumptions.length) - 1].startDate);
            var minDate = today <= maxDate ? today : maxDate;
            endDate = formatDate(consumptions[(consumptions === null || consumptions === void 0 ? void 0 : consumptions.length) - 1].rangeType, (_c = state === null || state === void 0 ? void 0 : state.consumptions) === null || _c === void 0 ? void 0 : _c.stepDefinition, minDate.toString(), (_d = state === null || state === void 0 ? void 0 : state.settings) === null || _d === void 0 ? void 0 : _d.language, true);
        }
        return endDate;
    }
    return '';
}
exports.getConsumptionsEndDate = getConsumptionsEndDate;
function getConsumptionsSum(state) {
    var _a, _b;
    var lang = (0, settingsSelectors_1.getLanguage)(state);
    var translation = (0, index_1.default)(lang ? lang : index_1.langTypes.FR);
    if (((_b = (_a = state === null || state === void 0 ? void 0 : state.consumptions) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        var sum = state.consumptions.data.reduce(function (acc, current) {
            return acc.add(new decimal_js_1.Decimal(current.value));
        }, new decimal_js_1.Decimal(0));
        return sum.valueOf().split('.').join(translation.common.floatingPoint);
    }
    return '0';
}
exports.getConsumptionsSum = getConsumptionsSum;
function getStepDefinitionConfig(state) {
    return {
        mode: state.consumptions.stepDefinition,
        month: state.consumptions.startMonth,
        day: state.consumptions.startDay,
        year: state.consumptions.startYear
    };
}
exports.getStepDefinitionConfig = getStepDefinitionConfig;
function getConsumptions(state) {
    return state.consumptions.data;
}
exports.getConsumptions = getConsumptions;
function getConsumptionsState(states) {
    return states.consumptions;
}
exports.getConsumptionsState = getConsumptionsState;
function isRemoteConsumption(states) {
    var consomptions = getConsumptions(states);
    if (consomptions.length > 0) {
        var firstConso = consomptions[0];
        if (firstConso.rangeType === 'Month' ||
            firstConso.rangeType === 'Day') {
            return true;
        }
        return false;
    }
}
exports.isRemoteConsumption = isRemoteConsumption;
function getCurrentSectionSubscriptions(states) {
    return states.consumptions.currentSectionSubscriptions;
}
exports.getCurrentSectionSubscriptions = getCurrentSectionSubscriptions;
function getToolTip(c, translation, lang, isEstimated) {
    if (isEstimated) {
        return (translation.consumption.onHover +
            ' ' +
            new Intl.DateTimeFormat(lang).format(new Date(c.startDate)) +
            '\n' +
            translation.consumption.global +
            ' : ' +
            c.value
                .toString()
                .split('.')
                .join(translation.common.floatingPoint) +
            translation.common.waterMeasuringUnit +
            '\n' +
            translation.consumption.real +
            ' : ' +
            c.realConsumptionValue
                .toString()
                .split('.')
                .join(translation.common.floatingPoint) +
            translation.common.waterMeasuringUnit);
    }
    else {
        return (c.value
            .toString()
            .split('.')
            .join(translation.common.floatingPoint) +
            translation.common.waterMeasuringUnit +
            ' ' +
            translation.consumption.onHover +
            ' ' +
            new Intl.DateTimeFormat(lang).format(new Date(c.startDate)));
    }
}
